export default "__VITE_ASSET__DF6sy4p3__"